export default "__VITE_ASSET__BXytNUQ$__ 74w, __VITE_ASSET__B2rvZ$fD__ 148w";